import {Component, Input} from "@angular/core";

@Component({
	selector: "image-container",
	template: `
		<div class="imagecontainer" [style.height.px]="height" [style.width.px]="width">
			<img src="{{_src}}" alt="{{alt}}">
		</div>
	`,
	styles: [
		`.imagecontainer {
			position: relative;
		}`,
		`.imagecontainer > img {
			bottom: 0;
			left: 0;
			margin: auto;
			position: absolute;
			right: 0;
			top: 0;
			max-width: 100%;
			max-height: 100%;
		}`,
	],
})
export class ImageContainerComponent {
	@Input() height: number;
	@Input() width: number;
	@Input()
	set src (src: string) {
		this._src = src;
	}
	@Input() alt: string;
	_src: string;

	updateImage (photoURL: string) {
		this._src = photoURL;
	}
}
